import { reactive } from 'vue';

export default {
  name: 'PurchaseSummaryComponent',
  props: {
    preview: {
      type: Object,
      required: false,
      default: null,
    },
    options: {
      type: Object,
      required: false,
      default: null,
    }
  },
  setup(props) {
    const state = reactive({

    });

    const formatPrice = (cents) => {
      const dollars = (cents / 100).toFixed(2);
      const parts = dollars.split(".");
      if (parts[1] === "00") {
        return `$${parts[0]}`;
      }
      return `$${dollars}`;
    };

    return { state, formatPrice };
  },
  methods: {
  }
};
